<div class="crop-settings" *ngIf="this.cropSettings">
  <label class="frame-format-label">{{ title }}</label>
  <table>
    <tr>
      <td></td>
      <td>
        TOP - %
        <icn-number-input
          [min]="0"
          [max]="calculateTopMax()"
          [step]="0.1"
          [useDefaultHtmlInput]="true"
          [(value)]="cropSettings.top"
          (valueChange)="valueUpdated.emit()"
        ></icn-number-input>
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        LEFT - %
        <icn-number-input
          [min]="0"
          [max]="calculateLeftMax()"
          [step]="0.1"
          [useDefaultHtmlInput]="true"
          [(value)]="cropSettings.left"
          (valueChange)="valueUpdated.emit()"
        ></icn-number-input>
      </td>

      <td>
        <ichannel-button
          [label]="'RESET'"
          class="apply-button"
          [theme]="'BLACK'"
          (click)="resetCropSettings()"
          >APPLY</ichannel-button
        >
      </td>
      <td>
        RIGHT - %
        <icn-number-input
          [min]="0"
          [max]="calculateRightMax()"
          [step]="0.1"
          [useDefaultHtmlInput]="true"
          [(value)]="cropSettings.right"
          (valueChange)="valueUpdated.emit()"
        ></icn-number-input>
      </td>
    </tr>
    <tr>
      <td></td>
      <td>
        BOTTOM - %
        <icn-number-input
          [min]="0"
          [max]="calculateBottomMax()"
          [step]="0.1"
          [useDefaultHtmlInput]="true"
          [(value)]="cropSettings.bottom"
          (valueChange)="valueUpdated.emit()"
        ></icn-number-input>
      </td>
      <td></td>
    </tr>
  </table>
</div>
